export const base_account_config = {
	flags: {
		has_location_bounds_migrated: false,
		allow_multi_delivery_slot_selection: true
	},
	add_items: {
		limit: {
			value: 3,
			info: {
				title:
					'For ease of pre-scheduled meal deliveries, add-ons are limited to 3 items per meal.',
				description: '* You can always order more at www.vibrantliving.in'
			}
		}
	}
};
